export function addCurrent(calledflowstatus) {
    return {
        type: 'ADD_CURRENT',
        calledflowstatus,
    }
}
